import type { RezaChangeModalProps } from '@gov-nx/core/hooks';
import { RezaChangeFormDialog } from './RezaChangeFormDialog';

export const RezaChangeModal = ({
	isOpen,
	title,
	onClose,
	optionsData,
	activeSwitcherReza,
	setActiveSwitcherReza,
}: RezaChangeModalProps) => {
	if (!isOpen) {
		return null;
	}
	return (
		<RezaChangeFormDialog
			isOpen={isOpen}
			title={title}
			activeSwitcherReza={activeSwitcherReza}
			setActiveSwitcherReza={setActiveSwitcherReza}
			onClose={onClose}
			optionsData={optionsData}
		/>
	);
};
